import type { StaticImageData } from "next/image";

import { Github } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { IconType } from "react-icons";
import { FaGoogleDrive } from "react-icons/fa6";

import GithubVector from "@/app/assets/vectors/github.svg";
import GoogleDriveVector from "@/app/assets/vectors/google-drive.svg";

export type ConnectionId = "drive" | "github";

export type Connection = {
  id: ConnectionId;
  name: string;
  Icon: LucideIcon | IconType;
  vector: StaticImageData;
  description: string;
  authRoute: string;
};

export const CONNECTIONS: Connection[] = [
  {
    id: "github",
    name: "GitHub",
    Icon: Github,
    vector: GithubVector,
    description:
      "Let Scout read GitHub repos, make PRs, and export to new repos",
    authRoute: "/api/auth/github",
  },
  {
    id: "drive",
    name: "Google Drive",
    Icon: FaGoogleDrive,
    vector: GoogleDriveVector,
    description: "Let Scout import and export Google Drive files",
    authRoute: "/api/auth/google",
  },
];

export const getConnection = (id: ConnectionId): Connection | undefined => {
  return CONNECTIONS.find((conn) => conn.id === id);
};
